import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { guardarPushToken, eliminarPushToken } from './api';

let isRegistered = false;
let tokenDispositivo = null;   // token FCM de este móvil, para desvincularlo al cerrar sesión

export async function registrarPushNotifications(navigate) {
  if (!Capacitor.isNativePlatform() || isRegistered) return;

  try {
    // Pedir permiso
    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive !== 'granted') {
      console.log('Push: permiso denegado');
      return;
    }
    // Marcado ya: si se llama otra vez antes de que llegue el token, no se duplican los listeners
    isRegistered = true;

    // Registrar en FCM
    await PushNotifications.register();

    // Recibir token
    PushNotifications.addListener('registration', async (token) => {
      try {
        const plataforma = Capacitor.getPlatform() === 'ios' ? 'ios' : 'android';
        tokenDispositivo = token.value;
        await guardarPushToken(token.value, plataforma);
      } catch (e) {
        console.error('Error guardando push token:', e);
      }
    });

    // Error de registro
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });

    // Notificacion recibida con app abierta (silenciosa — solo foreground)
    PushNotifications.addListener('pushNotificationReceived', () => {});

    // Click en notificacion
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const data = action.notification.data;
      if (navigate && data) {
        if (data.tipo === 'incidencia' && data.id) {
          navigate(`/incidencias/${data.id}`);
        } else if (data.tipo === 'anuncio' && data.id) {
          navigate(`/tablon/${data.id}`);
        }
      }
    });
  } catch (e) {
    isRegistered = false;
    console.error('Error registrando push:', e);
  }
}

// Al cerrar sesión: desvincular este móvil del usuario (si no, le seguían llegando sus avisos a quien
// entrara después en el mismo móvil) y dejarlo listo para que el siguiente usuario lo registre.
// Hay que llamarlo ANTES del logout: el DELETE necesita la sesión todavía válida.
export async function desregistrarPushNotifications() {
  if (!Capacitor.isNativePlatform()) return;
  if (tokenDispositivo) {
    await eliminarPushToken(tokenDispositivo).catch(() => {});
  }
  await PushNotifications.removeAllListeners().catch(() => {});
  tokenDispositivo = null;
  isRegistered = false;
}
